// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__39c3_","error":"Textarea_error__CVBYP","readonly":"Textarea_readonly__2XeHX","disabled":"Textarea_disabled__a5bLT"};